import * as angular from 'angular';

const rootContent = '/Content/Html/';

export class UrlService {
    getQueryString(args: string[]) {
        var ret = [];
        for (var key in args) {
            if (args.hasOwnProperty(key)) {
                ret.push(encodeURIComponent(key) + '=' + encodeURIComponent(args[key]));
            }
        }
        return ret.join('&');
    }

    get(base: string, args: string[]) {
        var queryString = this.getQueryString(args);
        return queryString
            ? base + '?' + queryString
            : base;
    }

    getRetailersHtmlUrl(path: string) {
        return rootContent + 'retailer/' + path + '.html';
    }

    getAdminHtmlUrl(path: string) {
        return rootContent + 'admin/' + path + '.html';
    }

    getJispPayHtmlUrl(path: string) {
        return rootContent + 'jisppay/' + path + '.html';
    }

    getShopperHtmlUrl(path: string) {
        return rootContent + 'shopper/' + path + '.html';
    }

    getCommonHtmlUrl(path: string) {
        return rootContent + 'common/' + path + '.html';
    }
}

angular.module('app.common').service('urlService', UrlService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/url.service.ts